module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-client-list-filter-form filter-form"
  }, [_c('div', {
    staticClass: "row",
    class: {
      'medium-unstack': _vm.rowUnstack
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.query),
      expression: "search.query"
    }],
    staticClass: "input-group-field",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.search.query)
    },
    on: {
      "keyup": _vm.enterSubmit,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "query", $event.target.value)
      }
    }
  }), _c('span', {
    staticClass: "input-group-label"
  }, [_c('span', {
    staticClass: "fa fa-search",
    on: {
      "click": _vm.filteredSearch
    }
  })])])]), (_vm.balance) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.balance),
      expression: "search.balance"
    }],
    staticClass: "input-group-field",
    attrs: {
      "type": "text",
      "placeholder": "Balance filter"
    },
    domProps: {
      "value": (_vm.search.balance)
    },
    on: {
      "keyup": _vm.balanceSubmit,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "balance", $event.target.value)
      }
    }
  }), _c('span', {
    staticClass: "input-group-label",
    on: {
      "click": _vm.balanceSearch
    }
  }, [_c('span', {
    staticClass: "fa fa-search"
  })])])]) : _vm._e(), (_vm.actionButton) ? _c('div', {
    staticClass: "columns"
  }, [_c('a', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1dbd2a90!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/filters/SearchInputForm.vue
// module id = 2315
// module chunks = 1